/**
 *
 */
const detectOperatingSystem = () => {
  if (typeof navigator == 'undefined') {
    return 'Unknown';
  }

  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Check for Android
  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  // Check for iOS
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  // Check for Windows
  if (/Win/.test(navigator.platform)) {
    return 'Windows';
  }

  // Check for macOS
  if (/Mac/.test(navigator.platform)) {
    return 'macOS';
  }

  // Check for Linux
  if (/Linux/.test(navigator.platform)) {
    return 'Linux';
  }

  return 'Unknown';
};

/**
 *
 */
const detectIsMobile = () => {
  const os = detectOperatingSystem();
  return os === 'Android' || os === 'iOS';
};

/**
 *
 */
const detectBatteryStatus = async () => {
  if (typeof navigator == 'undefined') {
    return null;
  }

  if ('getBattery' in navigator) {
    const battery = await navigator.getBattery();
    return {
      level: battery.level * 100,
      charging: battery.charging,
      chargingTime: battery.chargingTime,
      dischargingTime: battery.dischargingTime,
    };
  } else {
    return null;
  }
};

/**
 *  Provides static methods for retrieving information about the current device.
 *  This class is useful for implementing platform-specific functionality or optimizations in applications.
 */
export class Device {
  /**
   * This method helps in identifying the operating system, which can be useful for adapting features
   * or styles specific to different operating systems.
   */
  static operatingSystem = detectOperatingSystem;

  /**
   *  This method is useful for determining whether to enable or disable mobile-specific features,
   *  or for adjusting the layout and functionality based on the device type.
   */
  static isMobile = detectIsMobile;

  /**
   * Retrieves the battery status of the device (if supported).
   */
  static batteryStatus = detectBatteryStatus;
}
